export default __webpack_public_path__ + "static/media/completedIcon.2b33fd5e.svg";